import React, { useEffect, useState } from "react";
import { Button, Container, Row, Col, Form, Modal, Table, Stack, TabPane, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Servicios
import cursoespecialService from "../../services/cursoespecial.service";

const CursosEspeciales = () => {
    const [cursos, setCursos] = useState([]);
    const [nombreCurso, setNombreCurso] = useState('');

    useEffect(() => {
        cargarCursos();
    }, []);

    function cargarCursos() {
        //Obtenemos los cursos
        cursoespecialService.getAll()
            .then(res => {
                setCursos(res.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const ingresarCurso = () => {
        if (nombreCurso === "") {
            alert("Debe ingresar un nombre!");
            return;
        }
        cursoespecialService.create({ nombre: nombreCurso })
            .then(res => {
                console.log(res);
                toast.info("Curso Ingresado Correctamente!", {
                    position: "top-center",
                    autoClose: 1000
                });
                cargarCursos();
            }).catch(err => {
                console.error(err);
            });
    }

    function buttonFormat(cell, row) {
        return <Button variant="danger" onClick={() => eliminarCurso(row.id)}><FontAwesomeIcon icon="fa-solid fa-trash-can" /></Button>;
    }

    const eliminarCurso = (id) => {
        if (window.confirm("Esta seguro de eliminar el Curso?")) {
            cursoespecialService.eliminarCurso(id)
                .then(data => {
                    toast.info("Curso Eliminado Correctamente!", {
                        position: "top-center",
                        autoClose: 1000
                    });
                    cargarCursos();
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    function onAfterSaveCell(row, cellName, cellValue) {
        if (cellName === "nombre") {
            cursoespecialService.updateCurso(row.id, { nombre: cellValue })
                .then(resp => {
                    console.log(resp);
                    toast.info("Curso editado correctamente!!", {
                        position: "top-right",
                        autoClose: 1000
                    });
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    function onBeforeSaveCell(row, cellName, cellValue) {
        // You can do any validation on here for editing value,
        // return false for reject the editing
        

    }

    const cellEditProp = {
        mode: 'click',
        blurToSave: true,
        //beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
        afterSaveCell: onAfterSaveCell  // a hook for after saving cell
    };

    return (
        <Container>
            <Row>
                <Col sm={4}>
                    <h3>Ingresar Curso:</h3>
                    <Form.Group>
                        <Form.Label>Nombre Curso:</Form.Label>
                        <Form.Control type="text" onChange={(e) => setNombreCurso(e.target.value)} />
                    </Form.Group>
                    <div className="mt-3"></div>
                    <Button variant="success" onClick={ingresarCurso}>Ingresar</Button>
                </Col>
                <Col>
                    <h3 className="text-center">Lista de Cursos</h3>
                    <BootstrapTable data={cursos} cellEdit={cellEditProp}>
                        <TableHeaderColumn dataField="id" isKey>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="nombre">Nombre</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={buttonFormat} width="15%" tdStyle={{ textAlign: "center", whiteSpace: 'normal', wordWrap: 'break-word' }} editable={false}>Eliminar</TableHeaderColumn>
                    </BootstrapTable>
                </Col>
            </Row>
        </Container>
    )
}

export default CursosEspeciales;